import React, { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'
import SpeedCombineData from 'src/Home/SpeedMeter/SpeedCombineData'
import AdditionalDetail from 'src/Home/AdditionalDetail'
import CardInfo from 'src/Component/CardInfo'
import { ReactComponent as InfoIcon } from 'images/info_icon.svg'
import { ReactComponent as AgentIcon } from 'images/agent.svg'
import ExpectationDetail from 'src/Result/ExpectationDetail'
import { Route } from 'src/Common/Route'
import { RouteComponentProps } from 'react-router-dom'
import useResultState, { Screen } from 'src/Result/useResultState'
import { ReactComponent as SpeedTestLogo } from 'images/speed-test-logo.svg'
import { useHistory } from 'react-router-dom'
import EventSender from 'src/Utils/EventSender'
import { analytics } from 'src/Analytics'
import {
  ExperiencingNetworkIssueTappedEvent,
  SpeedTestQuestionsTappedEvent,
} from 'src/Analytics/SpeedTestEvents'
import useAppStack from 'src/App/useAppStack'
import { localize } from 'src/lib/localize'
import { SpeedCheckContext } from 'src/lib/ookla_speed_test/SpeedCheckContext'
import iPApi from 'src/IPApi'
import { GetProviderResponse } from 'src/IPApi/Response'
import { NETWORK_TYPE_MOBILE, NETWORK_TYPE_WI_FI } from 'src/Common/Constant'
import { AppBrandingSources } from 'src/white-label/AppBrandingSources'
import {
  APP_BRANDING_KEY,
  getWhiteLabelInfo,
} from 'src/white-label/FindWhiteLabel'
import { theme, useTheme } from 'src/Styles/theme'
import { SpeedResultState } from 'src/Common/SpeedResultState'
import { Title1 } from 'src/Styles/text-styles'
import { AppThemeProvider } from 'src/Styles/theme'
import { WhiteLabelContext } from 'src/white-label'

const Container = styled.div`
  flex: 1;
  @media (max-width: 768px) {
    margin-top: 16px;
    padding-bottom: 40px;
  }

  @media (min-width: 1024px) {
    margin-left: 160px;
    margin-right: 160px;
    margin-top: 48px;
    padding-bottom: 40px;
  }
`

const MobileContainer = styled.div`
  @media (max-width: 768px) {
    margin-left: 32px;
    margin-right: 32px;
  }
`

const InnerContainer = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
  flex-wrap: wrap;
`

const StatusContainer = styled.div<{ backgroundColor: string }>`
  border-radius: 14px;
  box-shadow: 0px 1px 1px ${theme.colors.boxShadowColor};
  elevation: 1;
  background-color: ${({ backgroundColor }) => backgroundColor};
  padding: 12px;
  margin-top: 16px;
  margin-left: 4px;
  margin-right: 4px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`
const SpeedStatusText = styled(Title1)`
  @media (max-width: 768px) {
    font-weight: 600;
  }
  @media (min-width: 768px) {
    font-weight: 400;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  justify-content: center;
  align-self: center;
`

const Col = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-self: flex-start;

  @media (max-width: 768px) {
    &:not(:last-child) {
      margin-bottom: 16px;
    }

    &:not(:first-child) {
      margin-top: 0px;
      margin-bottom: 8px;
    }

    &:first-child {
      margin-top: 16px;
    }

    &:last-child {
      margin-bottom: 16px;
    }
  }

  @media (min-width: 768px) {
    margin: 16px;
  }
`

const Space = styled.div`
  @media (max-width: 769px) {
    margin-top: 0px;
  }

  @media (min-width: 769px) {
    margin-top: 16px;
  }
`

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 32px;
  @media (max-width: 768px) {
    padding-top: 24px;
  }
`

const speedCheckQuestionTitle = localize('TITLE')('Speed check questions?')
const speedCheckQuestionDescription = localize('LABEL')(
  'Learn about speed check and understanding the results'
)

const experincingNetworkIssueTitle = localize('TITLE')(
  'Experiencing network issues? We can help!'
)
const experincingNetworkIssueDescription = localize('LABEL')(
  'Instantly talk to a live tech analyst via call or chat for help with your network'
)

const slowNetworkStatusText = localize('LABEL')(
  'Your internet speed is very slow!'
)

const averageNetworkStatusText = localize('LABEL')(
  'Your internet speed is average!'
)

const fastNetworkStatusText = localize('LABEL')(
  'Your internet speed is very fast!'
)

const maskIpAddress = (ipAddress: string) => {
  const ipArray = ipAddress.split('.')
  const appBrandingKey = localStorage.getItem(APP_BRANDING_KEY)
  if (appBrandingKey === AppBrandingSources.VODAFONE) {
    return ipArray[0] + '.' + ipArray[1] + '.0.0'
  } else {
    return ipArray[0] + '.' + ipArray[1] + '.' + ipArray[2] + '.0'
  }
}

interface Props {
  props: RouteComponentProps
}

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ props }: Props) => {
  console.log('Props: ' + JSON.stringify(props))
  const { resultData, resultState } = useResultState(props, Screen.Result)
  const history = useHistory()
  const [isLiveHelpFeatureEnabled, setIsLiveHelpFeatureEnabled] = useState(
    false
  )
  const { push } = useAppStack()
  const { dispatch } = useContext(SpeedCheckContext)
  const [location, setLocation] = useState<string>()
  const [networkType, setNetworkType] = useState<string>()
  const [isp, setIsp] = useState<string>()

  const {
    fastOuterRingColor,
    slowOuterRingColor,
    unstableOuterRingColor,
  } = useTheme().colors

  const getCardColor = (resultState: SpeedResultState) => {
    switch (resultState) {
      case SpeedResultState.FAST:
        return fastOuterRingColor
      case SpeedResultState.SLOW:
        return slowOuterRingColor
      case SpeedResultState.UNSTABLE:
        return unstableOuterRingColor
      default:
        return fastOuterRingColor
    }
  }

  const getStatusText = (resultState: SpeedResultState) => {
    switch (resultState) {
      case SpeedResultState.FAST:
        return fastNetworkStatusText
      case SpeedResultState.SLOW:
        return averageNetworkStatusText
      case SpeedResultState.UNSTABLE:
        return slowNetworkStatusText
      default:
        return fastNetworkStatusText
    }
  }

  useEffect(() => {
    dispatch({
      type: 'RESET',
      payload: {
        download: 0,
        upload: 0,
        ping: 0,
        sortedServer: undefined,
        clientIP: '',
        isSpeedCheckRunning: false,
        isOptimalLocationLoaded: false,
      },
    })
    const data = localStorage.getItem('isLiveHelpFeatureEnabled')
    if (data === 'true') {
      setIsLiveHelpFeatureEnabled(true)
    } else {
      setIsLiveHelpFeatureEnabled(false)
    }
  }, [dispatch])

  const onNavigate = () => {
    history.push(Route.SPEED_TEST_DETAIL)
    push()
    analytics.trackEvent(SpeedTestQuestionsTappedEvent())
  }

  const openTechSupportDeviceOnClient = () => {
    analytics.trackEvent(ExperiencingNetworkIssueTappedEvent())
    try {
      const event = {
        view: 'ExperienceCard',
        type: 'Click',
      }
      EventSender(JSON.stringify(event))
    } catch (e) {
      //doNothing
    }
  }
  const ipApi = iPApi()

  useEffect(() => {
    if (resultData.client_ip && resultData.client_ip !== '') {
      const maskedIpAddress = maskIpAddress(resultData.client_ip)
      ipApi
        .getProviderResponse(maskedIpAddress)
        .then((res: GetProviderResponse | null) => {
          if (!res) {
            return
          }

          if (res.city !== undefined && res.regionName !== undefined) {
            resultData.location = res.city + ', ' + res.regionName
          }
          resultData.network_type = res.mobile
            ? NETWORK_TYPE_MOBILE
            : NETWORK_TYPE_WI_FI
          resultData.provider_name = res.isp
          if (res.city !== undefined && res.regionName !== undefined) {
            setLocation(res.city + ', ' + res.regionName)
          }
          setNetworkType(resultData.network_type)
          setIsp(res.isp)
        })
    }
  }, [ipApi, resultData, resultData.client_ip])

  const appBrandingKey = localStorage.getItem(APP_BRANDING_KEY)
  const whiteLabel = getWhiteLabelInfo(appBrandingKey ? appBrandingKey : 'pg3')

  return (
    <WhiteLabelContext.Provider value={whiteLabel}>
      <AppThemeProvider theme={whiteLabel.theme}>
        <Container>
          <MobileContainer>
            <InnerContainer>
              <Col>
                <SpeedCombineData
                  download={resultData.download.toString()}
                  upload={resultData.upload.toString()}
                  ping={resultData.latency.toString()}
                  resultState={resultState}
                />
                <LogoContainer>
                  <SpeedTestLogo />
                </LogoContainer>
                <StatusContainer backgroundColor={getCardColor(resultState)}>
                  <SpeedStatusText>
                    {getStatusText(resultState)}
                  </SpeedStatusText>
                </StatusContainer>
              </Col>
              <ExpectationDetail resultState={resultState} />
            </InnerContainer>
            <InnerContainer>
              <Col>
                <AdditionalDetail
                  serverHost={resultData.server_host}
                  ipAddress={resultData.client_ip}
                  provider={isp}
                  location={location}
                  serverLocation={`${resultData.city_name} ${resultData.country_name}`}
                  showAllCategory={true}
                  network_type={networkType}
                />
              </Col>
              <Space />

              {isLiveHelpFeatureEnabled && (
                <Col>
                  <CardInfo
                    title={experincingNetworkIssueTitle}
                    description={experincingNetworkIssueDescription}
                    InfoIcon={AgentIcon}
                    onPress={openTechSupportDeviceOnClient}
                  />
                </Col>
              )}

              <Col>
                <CardInfo
                  title={speedCheckQuestionTitle}
                  description={speedCheckQuestionDescription}
                  InfoIcon={InfoIcon}
                  onPress={onNavigate}
                />
                <Space />
              </Col>
            </InnerContainer>
          </MobileContainer>
        </Container>
      </AppThemeProvider>
    </WhiteLabelContext.Provider>
  )
}
